import ImportForms from "../../../sources/import/ImportForms";
import type { PreparationViewProps } from "../preparationView";
import type { ImportIntent } from "../threadIntent";

/**
 * The import's preparation (web-app.md WA-12): batch 4's import form is its input view. Start
 * uploads or connects through module B, then this view turns into the update Thread the
 * server made for the new commit; a JSON Lines file imports directly and shows its result here.
 */
export default function ImportPreparation({ intent, requestKey, onStarted }: PreparationViewProps<ImportIntent>) {
  // Each preparation starts with its own fields.
  return <ImportForms key={requestKey} projectId={intent.projectId} corpusId={intent.corpusId} onStarted={onStarted} />;
}
